<template>
  <div
    v-if="showBlock"
    class="reviews-bottom d-flex align-center justify-center"
    :class="isMobile ? 'flex-column' : 'ga-4'"
    data-qa="lpu_reviews_bottom"
  >
    <v-btn
      v-if="redirectHref"
      depressed
      height="52"
      :href="redirectHref"
      :block="isMobile"
      class="reviews-bottom__btn branding-btn rounded-20 text-subtitle-1 text-none"
      :class="isMobile ? 'branding-btn--primary w-100' : 'branding-btn--background'"
      data-qa="show_more_list_item"
      data-reviews-list-yandex-goals="reviews_list_click_show_more_reviews_redirect"
    >
      {{ showMoreLabel }}
    </v-btn>
    <v-btn
      v-else-if="showExpandButton"
      depressed
      height="52"
      :block="isMobile"
      class="reviews-bottom__btn branding-btn rounded-20 text-subtitle-1 text-none"
      :class="isMobile ? 'branding-btn--primary w-100' : 'branding-btn--background'"
      data-qa="show_more_list_item"
      data-reviews-list-yandex-goals="reviews_list_click_show_more_reviews_lpu_page"
      @click="emit('expand')"
    >
      {{ showMoreLabel }}
    </v-btn>
    <ReviewsLeaveBtn
      v-if="showLeaveButton"
      :lpu-id="lpuId"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import ReviewsLeaveBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsLeaveBtn.vue'
import { VISIBLE_RATES_LIMIT } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getPageRates'

const props = defineProps<{
  allrates: number
  ratesCount: number
  lpuId: number
  ratesPath: string
  canLeaveReview: boolean
  isExpanded: boolean
}>()

const isMobile = useIsMobile()

const emit = defineEmits(['expand'])

const visibleCount = computed(() => Math.min(VISIBLE_RATES_LIMIT, props.ratesCount))
const extraCount = computed(() => Math.max(0, props.allrates - visibleCount.value))
const hasHiddenOnPage = computed(() => props.ratesCount > visibleCount.value)
const isExpandable = computed(() => (
  extraCount.value > 0
  && hasHiddenOnPage.value
  && props.allrates <= 10
))
const showBlock = computed(() => extraCount.value > 0)
const showExpandButton = computed(() => isExpandable.value && !props.isExpanded)
const showLeaveButton = computed(() => (
  isExpandable.value
  && props.isExpanded
  && props.canLeaveReview
))
const showMoreLabel = computed(() => {
  const label = tStatic('Показать ещё отзывы')

  if (props.allrates > 10 || extraCount.value <= 0) {
    return label
  }

  return `${label} (${extraCount.value})`
})
const redirectHref = computed(() => {
  if (props.allrates > 10 || (extraCount.value > 0 && !hasHiddenOnPage.value)) {
    return `${props.ratesPath}${isMobile.value ? '#h1_title' : '#tab-content'}`
  }

  return undefined
})
</script>

<style scoped lang="scss">
.reviews-bottom {
  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
